//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import RequestAction from '~/components/global/RequestAction'
import { getFlag } from '~/utils/languages'
import { vLog } from '~/utils/vLog'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import flags from '~/mixins/flags'
import dayjs from "~/modules/dayjs";

export default {
  name: 'DestinationsPage',
  filters: {
    numKeys (object) {
      if (object) {
        return Object.keys(object).length
      }
      return 0
    },
    rangeFormatter (value) {
      return `${value.min} - ${value.max}`
    },
    arrayToString (value) {
      return value.join(', ')
    },
    titlecase (value) {
      return value.replace(/\w\S*/g, txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase())
    }
  },
  components: { RequestAction },
  mixins: [pageMeta, flags],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      await mxGetMeta(ctx, {
        meta: {
          method: 'static'
        }
      })
      await ctx.store.dispatch('data/getContinents')
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      errorLocation: false,
      loading: false
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$Search.resetAllAttributes(true)
    next()
  },
  computed: {
    ...mapState({
      pageSeoData: state => state.pageData,
      lang: state => state.lang.locale
    }),
    ...mapGetters({
      continents: 'data/continents'
    }),
    getContinents () {
      return [...this.continents.countries].sort((a, b) => {
        const nextLength = a.cities.length
        const prevLength = b.cities.length
        return nextLength < prevLength ? 1 : -1
      }).map((country) => {
        return {
          ...country,
          cities: [...country.cities].sort((a, b) => {
            const nextLength = a.boat_count
            const prevLength = b.boat_count
            return nextLength < prevLength ? 1 : -1
          })
        }
      })
    },
    getRegions () {
      return [...this.continents.regions].sort((a, b) => a.boat_count < b.boat_count ? 1 : -1)
    },
    targetUrl () {
      return this.$route.path.replace(/\/$/, '')
    }
  }
}
